//export const apiPath1 = "https://toolease-api.ebistesthub.in/api/"
//export const imagePath = "https://toolease-api.ebistesthub.in/storage/"

// export const apiPath1 = "https://toolease-api-dev.ebistesthub.in/api/"
// export const imagePath = "https://toolease-api-dev.ebistesthub.in/"

export const apiPath1 = "https://teapi.ebissoft.com/api/"
export const imagePath = "https://teapi.ebissoft.com/storage/"